
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkAddPhoneToContactDto } from '../models/work-add-phone-to-contact-dto';
import { WorkAddMailToContactDto } from '../models/work-add-mail-to-contact-dto';

export function getCreateContactDtoFormGroup() {
return new FormGroup({
    userId: new FormControl<number | undefined>(undefined),
    businessunitId: new FormControl<number | undefined>(undefined, [Validators.required]),
    titleId: new FormControl<number | undefined>(undefined),
    categoryId: new FormControl<number | undefined>(undefined, [Validators.required]),
    statusId: new FormControl<number | undefined>(undefined),
    leadcategoryId: new FormControl<number | undefined>(undefined),
    leadsubcategoryId: new FormControl<number | undefined>(undefined),
    recomUserId: new FormControl<number | undefined>(undefined),
    recomContactId: new FormControl<number | undefined>(undefined),
    number: new FormControl<number | undefined>(undefined),
    company: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    firstName: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    lastName: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    street: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    addressAdditional: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    zipcode: new FormControl<string | undefined>('', [Validators.maxLength(10)]),
    city: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    canton: new FormControl<string | undefined>('', [Validators.maxLength(10)]),
    notes: new FormControl<string | undefined>(undefined),
    montageNotes: new FormControl<string | undefined>(undefined),
    postalSalutation: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    newsPostal: new FormControl<boolean | undefined>(true),
    newsElectronic: new FormControl<boolean | undefined>(true),
    photoPublished: new FormControl<boolean | undefined>(true),
    bankName: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    kontoinhaber: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    iban: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    archiveboxId: new FormControl<number | undefined>(undefined),
    contactImageId: new FormControl<number | undefined>(undefined),
    discountPercentage: new FormControl<number | undefined>(undefined),
    debtorPaymentDeadlineInDays: new FormControl<number | undefined>(undefined),
    skontoPercentage: new FormControl<number | undefined>(undefined),
    skontoDays: new FormControl<number | undefined>(undefined),
    phones: new FormControl<WorkAddPhoneToContactDto[]>([]),
    mails: new FormControl<WorkAddMailToContactDto[]>([]),
})
;
}
      